import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Mail, Check } from "lucide-react";

export default function ForgotPassword() {
    const { t } = useTranslation();
    const [email, setEmail] = useState("");
    const [sent, setSent] = useState(false);
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setError(""); setLoading(true);
        try {
            await api.post("/auth/forgot-password", { email });
            setSent(true);
        } catch (err) {
            setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
        } finally { setLoading(false); }
    };

    return (
        <div className="parchment min-h-[calc(100vh-4rem)] flex items-center justify-center px-6 py-16">
            <div className="w-full max-w-md p-card p-8 sm:p-10" data-testid="forgot-card">
                <div className="flex items-center gap-2 mb-4">
                    <div className="h-10 w-10 rounded-full flex items-center justify-center" style={{ background: "#1E1B4B", color: "#D4AF37" }}>
                        <Mail size={18} />
                    </div>
                    <div className="font-display text-3xl" style={{ color: "#1E1B4B" }}>{t("forgot.h")}</div>
                </div>
                <p className="text-sm mb-5" style={{ color: "#525252" }}>{t("forgot.sub")}</p>
                {sent ? (
                    <div className="p-4 rounded-2xl text-sm inline-flex items-center gap-2"
                         style={{ background: "#F5F0E6", color: "#1E1B4B" }} data-testid="forgot-sent">
                        <Check size={14} style={{ color: "#7F1D1D" }} /> {t("forgot.sent")}
                    </div>
                ) : (
                    <form onSubmit={submit} className="space-y-4">
                        <div>
                            <label className="block text-xs uppercase tracking-[0.22em] mb-1.5" style={{ color: "#7F1D1D" }}>{t("forgot.email")}</label>
                            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                                   className="w-full px-4 py-3 rounded-full border"
                                   style={{ borderColor: "#E5E0D8", background: "#FDFBF7" }}
                                   data-testid="forgot-email-input" />
                        </div>
                        {error && <div className="text-sm" style={{ color: "#7F1D1D" }} data-testid="forgot-error">{error}</div>}
                        <button type="submit" disabled={loading} className="btn-primary w-full disabled:opacity-60" data-testid="forgot-submit-button">
                            {loading ? "…" : t("forgot.submit")}
                        </button>
                    </form>
                )}
                <div className="mt-6 text-sm text-center">
                    <Link to="/login" className="underline" style={{ color: "#1E1B4B" }} data-testid="forgot-back-link">{t("forgot.back")}</Link>
                </div>
            </div>
        </div>
    );
}
